import {
  Component,
  OnInit,
  ChangeDetectorRef
} from '@angular/core';

import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

import { CartService } from '../../services/cart';
import { ProductService } from '../../services/product.service';
import { LanguageService } from '../../services/language.service';
import { BnNumberPipe } from '../../pipes/bn-number.pipe';


@Component({
  selector: 'app-offers',

  standalone: true,

  imports: [
    CommonModule,
    BnNumberPipe
  ],

  templateUrl: './offers.html',

  styleUrls: ['./offers.css']
})
export class Offers implements OnInit {

  apiUrl =
    'https://superbangladesh-api-1.onrender.com';

  allProducts: any[] = [];
  products: any[] = [];

  loading = true;
  errorMessage = '';

  constructor(
    private http: HttpClient,
    private productService: ProductService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    public cart: CartService,
    public languageService: LanguageService
  ) {}

  t(key: string): string {
    return this.languageService.translate(key);
  }

  ngOnInit(): void {

    // আগের দেখা তালিকা থাকলে সাথে সাথে দেখাই — কোনো লোডিং নেই
    const snap = this.productService.peekOffers();

    if (snap) {

      this.allProducts = snap;

      this.products = snap.filter(p => Number(p?.discount) > 0);

      this.loading = false;
    }

    // শুধু ডিসকাউন্টের প্রোডাক্ট আনে (ব্যাকএন্ড /api/products/offers) — ৫ মিনিট ক্যাশ
    this.productService
      .getOffersCached()
      .subscribe({

        next: (res) => {

          this.allProducts =
            Array.isArray(res) ? res : [];

          this.products =
            this.allProducts.filter(
              p => Number(p?.discount) > 0
            );

          this.loading = false;

          this.cdr.detectChanges();
        },

        error: () => {

          // আগের তালিকা দেখানো থাকলে এরর দিয়ে সেটা ঢাকব না
          if (this.products.length) {
            return;
          }

          this.errorMessage =
            this.t('couldNotLoadProducts');

          this.loading = false;

          this.cdr.detectChanges();
        }
      });
  }


  // =========================
  // DISCOUNTED PRICE (rounded)
  // =========================

  getFinalPrice(p: any): number {

    const price = Number(p?.price) || 0;
    const discount = Number(p?.discount) || 0;

    if (!discount) {
      return price;
    }

    return Math.round(price - (price * discount / 100));
  }


  // =========================
  // ADD TO CART
  // =========================

  addToCart(product: any, event?: Event): void {

    event?.preventDefault();
    event?.stopPropagation();

    if (
      product.stock !== undefined &&
      product.stock !== null &&
      Number(product.stock) <= 0
    ) {
      return;
    }

    this.cart.add({
      ...product,
      price: this.getFinalPrice(product)
    });

    this.cdr.detectChanges();
  }

  increaseQty(product: any, event?: Event): void {

    event?.stopPropagation();

    this.cart.increaseByProduct({
      ...product,
      price: this.getFinalPrice(product)
    });

    this.cdr.detectChanges();
  }

  decreaseQty(product: any, event?: Event): void {

    event?.stopPropagation();

    this.cart.decreaseByProduct(product);

    this.cdr.detectChanges();
  }

  getCartQty(product: any): number {
    return this.cart.getQty(product?.id);
  }


  // =========================
  // IMAGE
  // =========================

  getProductImage(url: string): string {

    if (!url) {
      return 'assets/no-image.png';
    }

    if (url.startsWith('http')) {
      return url;
    }

    if (url.startsWith('/uploads')) {
      return `${this.apiUrl}${url}`;
    }

    return `${this.apiUrl}/images/${url}`;
  }

  onImgError(event: Event): void {

    const img = event.target as HTMLImageElement;

    if (img.src.includes('no-image.png')) {
      return;
    }

    img.src = 'assets/no-image.png';
  }

  openProduct(id: number): void {

    if (!id) {
      return;
    }

    this.router.navigate(['/product', id]);
  }

  trackByProduct(index: number, product: any): any {
    return product?.id ?? index;
  }
}
